var watchlistCreate = {
	confirmBtn: "Ok",
	cancelBtn: "Abbrechen",
	title: "Erstellen Sie eine neue Beobachtungsliste",
	placeholder: "Name",
	nameInputLabel: "Name der Beobachtungsliste",
	nameInputTip: "Maximal 100 Zeichen – Gültige Zeichen: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ",
	validationErrors: {
		name: {
			invalidInput: "Name ist ungültig. Maximal 100 Zeichen – Gültige Zeichen: a-z A-Z -_?()'&\"# 0-9 ÄÖÜäöüÀÂÉÊÈËÌÏÎÔÙÛÇÆÑàâéêèëìïîôùûçæñ"
		}
	}
};
var de = {
	watchlistCreate: watchlistCreate
};

export { de as default, watchlistCreate };
